import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import type { FAQ } from "@/lib/productContent";

export function PDPFaq({ faqs }: { faqs: FAQ[] }) {
  return (
    <section aria-labelledby="faq-heading" className="mt-10 md:mt-16">
      <div className="mx-auto max-w-3xl text-center">
        <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-brand">
          Questions, answered
        </p>
        <h2
          id="faq-heading"
          className="mt-2 font-display text-3xl font-bold text-brand-deep md:text-4xl"
        >
          Frequently asked questions
        </h2>
      </div>
      <div className="mx-auto mt-8 max-w-3xl">
        <Accordion type="multiple" className="rounded-2xl border border-border bg-card">
          {faqs.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`faq-${i}`}
              className={i === faqs.length - 1 ? "border-b-0" : ""}
            >
              <AccordionTrigger className="px-5 py-4 text-left text-[14px] font-semibold leading-snug text-brand-deep hover:no-underline md:text-base">
                <h3 className="m-0 font-display">{f.q}</h3>
              </AccordionTrigger>
              <AccordionContent className="px-5 pb-4 text-sm leading-relaxed text-foreground/85">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
